import axios from 'axios';

export const registerStockNotification = async ({
  lang,
  country,
  token,
  sku,
  email,
  url
}: {
  lang: string;
  country: string;
  token: string;
  sku: string;
  email: string;
  url: string;
}): Promise<any> => {
  const URL = `${
    process.env.WP_API_URL || process.env.NEXT_PUBLIC_WP_API_URL
  }/v1/restock`;

  const config = {
    headers: {
      ['UYN-LANGUAGE']: lang,
      ['UYN-COUNTRY']: country,
      ['UYN-BEARER']: token
    }
  };

  try {
    const response = await axios.post(
      URL,
      {
        sku,
        email,
        url
      },
      config
    );

    return response;
  } catch (error) {
    return { error };
  }
};
